import { AccordionItem, Card } from "@dgs/core";
import styled from "styled-components";

export const Span = styled.span`
	grid-column: 1 / -1;
`;

export const Subheading = styled.span`
	font-size: ${({ theme }) => theme.fonts.sizes.large};
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

export const Small = styled.span`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
`;

export const GreyBox = styled(Card).attrs({ $variant: "outlined" as const })`
	display: grid;
	background-color: ${({ theme }) => theme.colors.palette.grey[10]};
	padding: ${({ theme }) => theme.spacing(4)};
	gap: ${({ theme }) => theme.spacing(2)};
`;

export const SummaryAccordionItem = styled(AccordionItem)`
	& button > span {
		font-size: ${({ theme }) => theme.fonts.sizes.large};
		font-weight: ${({ theme }) => theme.fonts.weights.bold};
	}
	padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const RegistrationShopSummarySection = styled.div`
	display: grid;
	gap: ${({ theme }) => theme.spacing(4)};
`;

export const Separator = styled.div`
	height: 1px;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.layout.background.separator};
`;
